import type { PublisherDetails } from 'src/constants/meloSources';
import { realEstateSources } from 'src/constants/meloSources';
import type { Publisher } from 'src/types/__generated__/graphql';

const getPublisherDetails = (rawPublisher: Pick<Publisher, 'name'>): PublisherDetails => {
    const publisher = rawPublisher.name in realEstateSources ? realEstateSources[rawPublisher.name] : undefined;
    return {
        name: publisher?.name ?? rawPublisher.name,
        logo: publisher?.logo,
    };
};
export default getPublisherDetails;
